import { getCachedConfig } from '@/api/config'

export function captchaSiteKey(): string | null {
  return getCachedConfig()?.turnstileSiteKey ?? null
}
